// FILE: initials.ts
// Purpose: Shared initials fallback for people and managed agents.
// Exports: `initials`.

/**
 * One or two letters standing in for a display name.
 *
 * Two words give two initials, one word gives one: "YB" is recognisably a
 * different person from "YA", but "Ya" taken off the front of a single name
 * is just a truncation and reads as noise next to the colour that already
 * distinguishes them.
 *
 * Split by code point, not by `charAt`, so an accented letter or an emoji name
 * does not come back as half a character.
 */
export function initials(displayName: string | null | undefined): string {
  const words = (displayName ?? "")
    .trim()
    .split(/\s+/)
    .filter((word) => word.length > 0);
  if (words.length === 0) return "?";

  const first = Array.from(words[0] ?? "")[0] ?? "";
  const last = words.length > 1 ? (Array.from(words.at(-1) ?? "")[0] ?? "") : "";
  const result = `${first}${last}`;
  return result.length > 0 ? result.toLocaleUpperCase() : "?";
}
